import React, { useState } from 'react';
import { 
  FaChartPie, FaShieldAlt, FaBuilding, FaGem, 
  FaCheckCircle, FaChevronDown, FaHandHoldingUsd, 
  FaCoins, FaBriefcase, FaCogs 
} from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
const AlternativeInvestments = () => {
  // State for Accordion FAQ toggling
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      q: "What are Alternative Investments?",
      a: "Alternative investments are financial assets that fall outside traditional categories like public equities, bonds, and cash. Examples include Alternative Investment Funds (AIFs), Real Estate Investment Trusts (REITs), Structured Products, Venture Capital, Private Equity, Commodities, and Precious Metals."
    },
    {
      q: "What is the minimum investment required for AIFs in India?",
      a: "As per SEBI regulations, the minimum investment amount for an investor in an Alternative Investment Fund (AIF Category I, II, or III) in India is generally ₹1 Crore, making these products suitable primarily for High Net Worth Individuals (HNIs) and institutional investors."
    },
    {
      q: "How do alternative investments help reduce portfolio volatility?",
      a: "Alternative investments typically have a low correlation to traditional stock and bond markets. During periods of public equity market downturns or economic volatility, uncorrelated alternative assets help stabilize portfolio returns and hedge against inflation."
    },
    {
      q: "What is the liquidity profile of alternative investments?",
      a: "Liquidity varies depending on the specific asset class. While publicly traded REITs, InvITs, and Gold ETFs offer daily market liquidity, private equity, venture capital, and real estate funds are illiquid and usually require long-term capital lock-in periods (e.g., 3 to 7 years)."
    }
  ];

  return (
    <main className="alternative-investments-page">
      <Helmet>
  {/* Basic SEO */}
  <title>Alternative Investment Services in Hyderabad | Alternative Investments | Lotoswealth</title>

  <meta
    name="description"
    content="Lotoswealth offers Alternative Investment Services in Hyderabad, providing access to Alternative Investment Funds (AIFs), private equity, private credit, structured products, real estate investments, and diversified investment opportunities to help investors build long-term wealth."
  />

  <meta
    name="keywords"
    content="Alternative Investment Services Hyderabad, Alternative Investments Hyderabad, Alternative Investment Funds Hyderabad, AIF Hyderabad, Private Equity Hyderabad, Private Credit Hyderabad, Structured Products Hyderabad, Real Estate Investments Hyderabad, Venture Capital Hyderabad, Hedge Funds Hyderabad, Wealth Management Hyderabad, Investment Advisor Hyderabad, Financial Advisor Hyderabad, Portfolio Diversification Hyderabad, High Net Worth Investments Hyderabad, HNI Investment Services Hyderabad, Asset Management Hyderabad, Long Term Investments Hyderabad, Investment Planning Hyderabad, Lotoswealth"
  />

  <meta name="robots" content="index, follow" />
  <meta name="author" content="Lotoswealth" />
  <meta name="language" content="English" />

  <link rel="canonical" href="https://www.lotoswealth.com/alternate-investments" />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Lotoswealth" />
  <meta property="og:url" content="https://www.lotoswealth.com/alternate-investments" />
  <meta
    property="og:title"
    content="Alternative Investment Services in Hyderabad | Lotoswealth"
  />
  <meta
    property="og:description"
    content="Explore Alternative Investment Services in Hyderabad with Lotoswealth. Invest in AIFs, private equity, private credit, structured products, real estate, and diversified investment opportunities."
  />
  <meta
    property="og:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Alternative Investment Services in Hyderabad | Lotoswealth"
  />
  <meta
    name="twitter:description"
    content="Diversify your portfolio with Alternative Investment Services in Hyderabad. Access AIFs, private equity, private credit, structured products, and long-term wealth creation with Lotoswealth."
  />
  <meta
    name="twitter:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />
</Helmet>
      {/* =========================================
          1. HERO SECTION (With Ticker & Slow Zoom)
      ========================================= */}
      <div className="hero-wrapper position-relative" style={{ height: '100vh', minHeight: '800px', overflow: 'hidden' }}>
        
        <div className="position-absolute top-0 start-0 w-100 h-100 z-0 animate-slow-zoom">
          <img 
            src="/images/alternate-investments.jpg" 
            alt="Alternative Investments Advisory" 
            className="w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Slanted Panels Overlay */}
        <div className="panels-container position-absolute top-0 start-0 w-100 h-100 z-1 d-flex">
          <div className="slanted-panel panel-1"></div>
          <div className="slanted-panel panel-2"></div>
          <div className="slanted-panel panel-3"></div>
          <div className="slanted-panel panel-4"></div>
        </div>

        {/* --- Floating Main Header Text (Perfectly Centered) --- */}
        <div className="container hero-main-text text-center position-absolute top-50 start-50 translate-middle z-3 w-100 px-4">
          <h1 className="fw-bold display-4 animate-slide-up delay-1 mb-3 text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
            Alternative Investments Advisory
          </h1>
          <h2 className="animate-slide-up delay-2 fw-bold text-white mb-4" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Unlock Non-Traditional Opportunities Beyond Public Markets
          </h2>
          <p className="hero-description animate-slide-up delay-3 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Welcome to Lotoswealth. Standard stocks and bonds are no longer the only pathways to wealth generation. Our Alternative Investment solutions give discerning investors access to non-correlated, high-potential asset classes designed to enhance risk-adjusted returns and insulate portfolios from public market volatility.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-4 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            From SEBI-registered Alternative Investment Funds (AIFs) and Real Estate Investment Trusts (REITs) to Structured Products and Precious Metals, we help you identify, evaluate, and integrate institutional-grade alternative assets into your core wealth strategy.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-5 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Diversify beyond conventional boundaries with expert due diligence, rigorous risk assessment, and institutional market access.
          </p>
        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker position-absolute bottom-0 w-100 z-3 bg-dark text-white border-top border-bottom border-secondary py-2" style={{ opacity: 0.9 }}>
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
            
            {/* Duplicated Set for Infinite Scrolling */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>
      </div>

      {/* =========================================
          2. WHY ALTERNATIVE INVESTMENTS MATTER (Soft Teal Theme)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f0f9f6' }}>
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 animate-slide-up delay-1">
              <h2 className="fw-bold mb-4 text-dark">
                Why Consider Alternative Investments?
              </h2>
              <p className="text-muted line-height-lg">
                Traditional stock and bond markets can experience high correlation during macroeconomic shocks, leaving portfolios vulnerable. Alternative investments provide access to private markets and non-correlated returns that remain largely independent of public equity fluctuations.
              </p>
              <p className="text-muted line-height-lg">
                Including alternative assets in a portfolio helps smooth out long-term volatility, offers strong inflation hedges through tangible assets, and unlocks access to early-stage growth and private credit yields not accessible on public stock exchanges.
              </p>
            </div>
            <div className="col-lg-6 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm border-start border-teal border-5">
                <h4 className="fw-bold text-teal mb-3">Key Portfolio Benefits</h4>
                <ul className="list-unstyled text-muted mb-0">
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Low Market Correlation:</strong> Protection against public equity market crashes.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Enhanced Yield Potential:</strong> Superior risk-adjusted returns from private credit & equity.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Inflation Protection:</strong> Real assets like real estate and commodities preserve purchasing power.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Institutional Access:</strong> Exposure to early-stage venture capital and private debt.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          3. OUR ALTERNATIVE PRODUCTS (Crisp White)
      ========================================= */}
      <section className="py-5 bg-white" style={{ backgroundImage: "url('/images/lotoswealth-bg.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">💎 Our Alternative Investment Offerings</h2>
            <p className="text-white">Curated non-traditional asset classes tailored for sophisticated investors.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-lg-4 col-md-6 animate-slide-up delay-1">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaChartPie size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Alternative Investment Funds (AIFs)</h5>
                <p className="text-muted small">Access to SEBI-registered Category I, II, and III AIFs covering private equity, venture capital, long-short hedge funds, and distressed asset funds.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-2">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaBuilding size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">REITs & InvITs</h5>
                <p className="text-muted small">Invest in commercial real estate and infrastructure projects through REITs and InvITs that yield regular, tax-efficient dividend income.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-3">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaCogs size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Structured Products</h5>
                <p className="text-muted small">Customized pre-packaged investments, including Market-Linked Debentures (MLDs), designed to offer capital protection while capturing upside equity market participation.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-4">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaHandHoldingUsd size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Private Credit & High-Yield Debt</h5>
                <p className="text-muted small">Tap into non-banking private lending opportunities and corporate debt offerings that deliver predictable, high-yield fixed returns.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-5">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaCoins size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Gold & Precious Metals</h5>
                <p className="text-muted small">Strategic allocation into Sovereign Gold Bonds (SGBs), Digital Gold, and Commodity ETFs to provide an enduring hedge against market systemic risk.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-6">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaBriefcase size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Venture Capital & Angel Funds</h5>
                <p className="text-muted small">Participate in early-stage startup funding and disruptive technological innovation through professionally managed angel and venture funds.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          4. OUR 5-STEP INVESTMENT PROCESS (Dark Slate)
      ========================================= */}
      <section className="py-5 text-white" style={{ backgroundColor: '#0a192f' }}>
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🔄 Our Alternative Investment Process</h2>
            <p className="text-light opacity-75">Disciplined due diligence and strategic asset sourcing.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-md-6 col-lg-4 animate-slide-up delay-1">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 1 – Liquidity & Risk Audit</h5>
                <p className="small text-muted mb-0">We evaluate your net worth, liquidity needs, and risk profile to determine the optimal allocation percentage for alternative assets.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-2">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 2 – Rigorous Due Diligence</h5>
                <p className="small text-muted mb-0">Our analysts perform exhaustive fund manager background checks, historical performance reviews, and operational risk evaluations.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-3">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 3 – Curated Deal Sourcing</h5>
                <p className="small text-muted mb-0">We select high-grade alternative products, AIFs, and debt structures that align with your return expectations and lock-in preferences.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 animate-slide-up delay-4">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 4 – Seamless Execution</h5>
                <p className="small text-muted mb-0">Assisting with legal documentation, subscription forms, accredited investor compliance, and smooth fund transfer execution.</p>
              </div>
            </div>

            <div className="col-md-12 col-lg-6 animate-slide-up delay-5">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 5 – Monitoring & Exit Management</h5>
                <p className="small text-muted mb-0">Tracking fund manager performance, underlying asset growth, distributions, and executing timely exit strategies upon maturity.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          5. WHO WE SERVE & WHY CHOOSE US (Soft Blue-Gray)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#eef2f5' }}>
        <div className="container py-4">
          <div className="row g-5">
            
            {/* Target Audience */}
            <div className="col-lg-5 animate-slide-up delay-1">
              <h3 className="fw-bold mb-4 text-dark">👥 Who Should Consider Alternatives?</h3>
              <p className="text-muted small mb-4">Alternative products are ideal for sophisticated investors aiming for non-traditional growth:</p>
              <div className="d-flex flex-wrap gap-2">
                {[
                  "High Net Worth Individuals (HNIs)", "Ultra-HNIs & Family Offices",
                  "Accredited Investors", "Business Promoters & Founders",
                  "Long-Term Capital Allocators", "Investors Seeking Inflation Hedges",
                  "Institutional-Grade Investors", "Experienced Portfolio Diversifiers"
                ].map((item, idx) => (
                  <span key={idx} className="badge bg-white text-dark border p-2 shadow-sm fs-6">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Why Choose Lotoswealth */}
            <div className="col-lg-7 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                <h3 className="fw-bold mb-3 text-dark">🏆 Why Lotoswealth for Alternative Assets?</h3>
                <p className="text-muted small mb-4">Alternative investments require unbiased evaluation and deep due diligence. Clients choose us because we offer:</p>
                <div className="row g-3">
                  {[
                    "Unbiased Fund Manager Evaluation", "Exhaustive Legal & Risk Due Diligence",
                    "Access to Exclusive & Institutional AIFs", "Transparent Fee Structures",
                    "Customized Illiquidity Risk Management", "Consolidated Wealth Reporting",
                    "Dedicated Alternative Asset Specialists", "Ongoing Portfolio Performance Monitoring"
                  ].map((item, idx) => (
                    <div key={idx} className="col-md-6 d-flex align-items-center">
                      <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                      <span className="small text-muted fw-bold">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          6. FREQUENTLY ASKED QUESTIONS (FAQ)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container py-4" style={{ maxWidth: '850px' }}>
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">❓ Frequently Asked Questions</h2>
            <p className="text-muted">Common queries regarding Alternative Investments & AIFs</p>
          </div>

          <div className="d-flex flex-column gap-3 animate-slide-up delay-2">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-3 shadow-sm border overflow-hidden"
              >
                <button 
                  className="w-100 text-start p-3 border-0 bg-white d-flex justify-content-between align-items-center fw-bold text-dark"
                  onClick={() => toggleFaq(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="pe-3">{faq.q}</span>
                  <FaChevronDown 
                    className={`text-teal transition-transform ${openFaq === index ? 'rotate-180' : ''}`} 
                    style={{ transition: 'transform 0.3s ease', minWidth: '16px' }}
                  />
                </button>
                {openFaq === index && (
                  <div className="p-3 pt-0 text-muted small border-top bg-light lh-lg">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================
          7. FINAL CTA SECTION (Deep Navy)
      ========================================= */}
      <section className="py-5 text-white text-center" style={{ backgroundColor: '#0f1e2d' }}>
        <div className="container py-4">
          <h2 className="fw-bold mb-3 animate-slide-up delay-1">Ready to Diversify Beyond Public Markets?</h2>
          <p className="text-light opacity-75 mb-4 animate-slide-up delay-2 mx-auto" style={{ maxWidth: '600px' }}>
            Schedule a private consultation with our alternative asset specialists today and explore exclusive non-traditional investment opportunities.
          </p>
          <button className="btn-custom-teal hover-lift px-5 py-3 fs-5 border-0 rounded text-white shadow animate-slide-up delay-3">
            Book an Alternative Investment Consultation
          </button>
        </div>
      </section>

    </main>
  );
};

export default AlternativeInvestments;